import { baseAPI } from "../../baseApi"

export const roadAccidentsApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение погодных условий конкретного ДТП
        fetchRoadAccidentWeatherConditions: builder.query<any, any>({
            query: (args) => ({
                url: `objects/RoadAccidents(${args.id})/WeatherConditions`
            })
        }),
        // запрос на получение погодных условий конкретного ДТП
        fetchRoadAccidentAmount: builder.mutation<any, any>({
            query: ({ startDate, endDate = new Date(), accidentTypes = [], allExceptAccidentTypes = [], coverStates = [], lightConditions = [], raions = [], weatherConditionCodes = "", victims }) => ({
                url: `objects/accidentAmount`,
                method: "POST",
                body: { startDate, endDate, accidentTypes, allExceptAccidentTypes, coverStates, lightConditions, raions, weatherConditionCodes, victims },
                headers: {
                    'Content-Type': 'application/json',
                }
            })
        })
    })
})

export const {
    useFetchRoadAccidentWeatherConditionsQuery,
    useFetchRoadAccidentAmountMutation
} = roadAccidentsApiSlice